import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, enumToStringConverter } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 300,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value + " " + `(${params.row.shortName})`,
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "paymentChannelType",
		headerName: "Payment Channel Type",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => enumToStringConverter(params.value),
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "--",
	},
	{
		field: "swiftCode",
		headerName: "Swift Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	
	...createdAtmodifiedAtActions
];
//  className="truncate"